/**
 * <addon-finish-filter>
 *
 * Wraps the modular add-ons list (snippets/modular-up-sell.liquid). When the
 * main product color changes (`variant:swatch`) it hides the add-on cards
 * and group selectors that must not be offered in that color, and the whole
 * list when nothing is left. snippets/addon-finish-excluded.liquid applies
 * the same rules to the first paint; <group-selector> applies them to its
 * own options through `AddonFinishFilter.excludes`.
 *
 * Each add-on's <bundle-item> carries the data from
 * snippets/addon-finish-data.liquid; `data-match-finishes` on this element
 * lists the parent colors whose add-ons must come in the same color.
 */
if (!customElements.get('addon-finish-filter')) {
  customElements.define(
    'addon-finish-filter',
    class AddonFinishFilter extends HTMLElement {
      static handleize(str) {
        return String(str || '')
          .toLowerCase()
          .trim()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9-]/g, '');
      }

      static excludes(bundleItem, finish, matchFinishes) {
        if (!bundleItem || !finish) return false;
        const data = bundleItem.dataset;
        if (data.finishExempt === 'true') return false;
        const token = `|${finish}|`;
        if ((data.finishHidden || '').includes(token)) return true;
        return (matchFinishes || '').includes(token) && !(data.finishColors || '').includes(token);
      }

      connectedCallback() {
        this.onSwatch = (event) => {
          const value = event?.detail?.value;
          if (value) this.apply(AddonFinishFilter.handleize(value));
        };
        document.addEventListener('variant:swatch', this.onSwatch);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:swatch', this.onSwatch);
      }

      apply(finish) {
        const matchFinishes = this.dataset.matchFinishes || '';
        let shown = 0;

        this.querySelectorAll('[data-finish-card]').forEach((card) => {
          const excluded = AddonFinishFilter.excludes(card.querySelector('bundle-item'), finish, matchFinishes);
          if (excluded && !card.classList.contains('hidden')) {
            card.querySelector('addon-stepper')?.changeQty?.(0);
          }
          card.classList.toggle('hidden', excluded);
          if (!excluded) shown += 1;
        });

        this.querySelectorAll('[data-finish-group]').forEach((wrapper) => {
          const items = [...wrapper.querySelectorAll('[data-group-hidden-item] bundle-item')];
          const excluded =
            items.length > 0 && items.every((item) => AddonFinishFilter.excludes(item, finish, matchFinishes));
          wrapper.classList.toggle('hidden', excluded);
          if (!excluded) shown += 1;
        });

        this.classList.toggle('hidden', shown === 0);
      }
    }
  );
}
